'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import { useStore } from '@base-ui/utils/store';
import { useSchedulerStoreContext } from "../../use-scheduler-store-context/index.mjs";
import { schedulerEventSelectors } from "../../scheduler-selectors/index.mjs";
/**
 * Hook that returns a function to trigger event creation via keyboard (Enter key).
 * Returns `undefined` when event creation is disabled.
 *
 * This is the keyboard counterpart of `useEventCreation` (which handles mouse clicks).
 * Both call `store.setOccurrencePlaceholder` with the same `type: 'creation'` placeholder.
 */
export function useKeyboardEventCreation(getCreationPlaceholder) {
  const store = useSchedulerStoreContext();
  const creationConfig = useStore(store, schedulerEventSelectors.creationConfig);
  if (creationConfig === false) {
    return undefined;
  }
  return () => {
    store.setOccurrencePlaceholder(_extends({
      type: 'creation'
    }, getCreationPlaceholder({
      creationConfig
    })));
  };
}